<template>
    <with-dimensions>
        <table-ish slot-scope="{ width }">
            <table-ish-row-router-link
                v-for="chat in chats"
                :key="chat.uuid"
                :to="{
                    name: $router.fix('dashboard.*.chats.show'),
                    params: {
                        chat: chat.uuid
                    }
                }"
                :class="{
                    'bg-blue-bg': chat.has_unread
                }"
            >
                <table-ish-cell
                    :class="{
                        'font-bold': chat.has_unread
                    }"
                >
                    <slot
                        name="primary"
                        :chat="chat"
                    />

                    <template slot="secondary">
                        <slot
                            name="secondary"
                            :chat="chat"
                        />
                    </template>
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    <template v-if="chat.updated_at && width > 500">
                        <template v-if="$moment(chat.updated_at).isAfter($moment().subtract(1, 'day'))">
                            {{ chat.updated_at | moment('HH:mm') }}
                        </template>

                        <template v-else>
                            {{ chat.updated_at | moment('D MMM YYYY') }}
                        </template>
                    </template>
                </table-ish-cell>
            </table-ish-row-router-link>
        </table-ish>
    </with-dimensions>
</template>

<script>
    export default {
        props: {
            chats: {
                type: Array,
                required: true
            }
        }
    }
</script>
